import { Button, Field, LogoMark, Text, colors, radii, useAction, useApi, useSession, brandSurface } from '@khaddi/ui';
import { useState } from 'react';
import { Pressable, ScrollView, View } from 'react-native';

const PHONE = /^0\d{9}$/;
const CODE = /^\d{6}$/;

export const LoginScreen = () => {
  const api = useApi();
  const { signIn } = useSession();
  const [phone, setPhone] = useState('');
  const [code, setCode] = useState('');
  const [step, setStep] = useState<'phone' | 'code'>('phone');
  const [devCode, setDevCode] = useState<string | null>(null);
  const [touched, setTouched] = useState(false);

  const request = useAction(async () => {
    const result = await api.auth.requestOtp(phone);
    setDevCode(result.devCode ?? null);
    setStep('code');
  });
  const verify = useAction(async () => {
    signIn(await api.auth.verifyOtp({ phone, code, app: 'shipper' }));
  });

  const phoneError = touched && !PHONE.test(phone) ? 'Số điện thoại gồm 10 số, bắt đầu bằng 0' : null;

  const submitPhone = () => {
    setTouched(true);
    if (PHONE.test(phone)) void request.run();
  };
  const submitCode = () => {
    if (CODE.test(code)) void verify.run();
  };
  const changePhone = () => {
    setStep('phone');
    setCode('');
    verify.clearError();
  };

  return (
    <ScrollView style={{ flex: 1, ...brandSurface }} contentContainerStyle={{ flexGrow: 1, width: '100%', maxWidth: 480, alignSelf: 'center' }}>
      <View style={{ flex: 1, paddingHorizontal: 24, paddingTop: 72, paddingBottom: 32, gap: 14, position: 'relative', overflow: 'hidden' }}>
        <View style={{ position: 'absolute', right: -60, top: 140 }} aria-hidden>
          <LogoMark size={240} opacity={0.08} />
        </View>
        <LogoMark size={64} />
        <View style={{ gap: 6 }}>
          <Text variant="label" color={colors.text} style={{ fontSize: 13 }}>
            Khao Ddi Shipper
          </Text>
          <Text variant="display" color={colors.text} style={{ fontSize: 32, lineHeight: 36 }}>
            Giao trà cùng Khao Ddi
          </Text>
          <Text variant="body" color={colors.text} style={{ fontSize: 13, lineHeight: 20 }}>
            Chủ động giờ chạy · nhận tiền theo ngày · đơn gần quán, quãng ngắn
          </Text>
        </View>
      </View>

      <View style={{ backgroundColor: colors.surface, borderTopLeftRadius: 26, borderTopRightRadius: 26, padding: 20, paddingBottom: 32, gap: 16 }}>
        {step === 'phone' ? (
          <>
            <Text variant="title">Đăng nhập</Text>
            <Field
              label="Số điện thoại"
              placeholder="09xx xxx xxx"
              value={phone}
              onChangeText={(value) => setPhone(value.replace(/\D/g, '').slice(0, 10))}
              keyboardType="phone-pad"
              autoComplete="tel"
              inputMode="tel"
              onSubmitEditing={submitPhone}
              error={phoneError ?? request.error}
            />
            <Button label="Gửi mã OTP" onPress={submitPhone} loading={request.pending} />
          </>
        ) : (
          <>
            <View style={{ gap: 4 }}>
              <Text variant="title">Nhập mã OTP</Text>
              <Text variant="caption">Mã 6 số đã gửi tới {phone}</Text>
            </View>
            {devCode ? (
              <View style={{ backgroundColor: colors.goldSoft, borderRadius: radii.sm, paddingHorizontal: 12, paddingVertical: 8 }}>
                <Text variant="caption" color={colors.goldText}>
                  Môi trường thử nghiệm · mã OTP: <Text variant="bodyStrong" color={colors.goldText} numeric>{devCode}</Text>
                </Text>
              </View>
            ) : null}
            <Field
              label="Mã OTP"
              placeholder="000000"
              value={code}
              onChangeText={(value) => setCode(value.replace(/\D/g, '').slice(0, 6))}
              keyboardType="number-pad"
              inputMode="numeric"
              autoComplete="one-time-code"
              autoFocus
              onSubmitEditing={submitCode}
              error={verify.error}
              style={{ letterSpacing: 6, fontSize: 18, fontWeight: '700' }}
            />
            <Button label="Xác nhận" onPress={submitCode} loading={verify.pending} disabled={!CODE.test(code)} />
            <Pressable accessibilityRole="button" onPress={changePhone} style={{ minHeight: 44, alignItems: 'center', justifyContent: 'center' }}>
              <Text variant="bodyStrong" color={colors.primaryText} style={{ fontSize: 13 }}>
                Đổi số điện thoại
              </Text>
            </Pressable>
          </>
        )}
      </View>
    </ScrollView>
  );
};
